module.exports = __webpack_public_path__ + "img/point.20aa9d9e.png";